var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoCompact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8014 0.0845337C8.99324 0.0845337 0.850586 8.40374 0.850586 18.4246C0.850586 25.7984 4.92191 32.0378 11.0289 35.063C11.0289 35.063 14.1749 36.5756 17.506 36.9537L21.7624 13.1306H28.6096L29.3499 8.78188H8.99324L8.43806 13.1306H15.1002L11.399 33.1723C6.21733 30.3362 2.70119 24.8531 2.70119 18.6137C2.70119 9.53817 9.91854 2.16433 18.8014 2.16433C27.6843 2.16433 34.9017 9.53817 34.9017 18.6137C34.9017 23.7186 32.4959 28.4455 28.9798 31.4706L30.0901 32.9832C34.1614 29.5799 36.7523 24.4749 36.7523 18.6137C36.7523 8.40374 28.6096 0.0845337 18.8014 0.0845337Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCompact);
export default __webpack_public_path__ + "static/media/logo_compact.0fd4002a1096c4016eba645c13d11e71.svg";
export { ForwardRef as ReactComponent };